<template>
  <div>
    <div class="text-right">
      <p>
        Monto Total USD :
        <span class="label label-danger" style="font-size: 22px">
          <template v-if="currency">
            {{ currency }}
          </template>
          <el-tag
            type="danger"
            effect="dark"
            v-if="sumaInvoiceCostUSD"
            style="font-size: 22px; color: white"
            >{{ sumaInvoiceCostUSD }}</el-tag
          >
          <el-tag
            type="danger"
            effect="dark"
            v-else
            style="font-size: 22px; color: white"
            >0.00</el-tag
          >
        </span>
      </p>
      <p>
        Monto Total :
        <span class="label label-danger" style="font-size: 22px">
          <template v-if="currency">
            {{ currency }}
          </template>
          <el-tag
            type="danger"
            effect="dark"
            v-if="sumaInvoiceCost"
            style="font-size: 22px; color: white"
            >{{ sumaInvoiceCost }}</el-tag
          >
          <el-tag
            type="danger"
            effect="dark"
            v-else
            style="font-size: 22px; color: white"
            >0.00</el-tag
          >
        </span>
      </p>
    </div>
    <div style="padding-bottom: 10px" class="text-right">
      <el-button
        type="primary"
        icon="el-icon-plus"
        circle
        @click="openDrawerAdd()"
      ></el-button>
    </div>
    <rabbey-table3
      style="width: 100%"
      ref="Obuy"
      :data="datosFormateados"
      :border="true"
      :fit="true"
      :stripe="true"
      :lazy="true"
      v-loading="loading"
      :columns="ColumnsOrderBuyTable"
      max-height="600"
      :actions="actions"
      @rtable-push-action="handlerAction"
    >
    </rabbey-table3>
    <el-drawer
      :visible.sync="drawerLine"
      size="60%"
      title="Lineas Solicitud Compra"
    >
      <rabbey-table3
        style="width: 100%"
        ref="Obuy"
        :data="dataDetails"
        :border="true"
        :fit="true"
        :stripe="true"
        :lazy="true"
        v-loading="loading"
        :columns="columnsLinesOrderBuy"
        max-height="600"
        :actions="OrderLinesActions"
        @rtable-push-action="handlerAction"
      ></rabbey-table3>
    </el-drawer>

    <!--Componente para editar orden de compra-->
    <editOrderBuy
      :isEditOrderLine="isEditOrderLine"
      :editOrderVisible="editOrderVisible"
      :orderData="orderData"
      @onOrderEdited="onOrderEdited"
      @onCloseOrderEdit="onCloseOrderEdit"
    />

    <!--DRAWER PARA AÑADIR ORDEN DE COMPRA-->

    <el-drawer
      title="Añadir orden de compra"
      size="60%"
      :visible.sync="drawerAddOrder"
    >
      <div style="margin: 20px">
        <el-form :ref="formName" label-position="left">
          <el-collapse>
            <el-collapse-item title="General">
              <el-col span="12">
                <el-form-item label="Estado Orden">
                  <el-select
                    size="mini"
                    v-model="formAddOrderBuy.OStatus"
                    placeholder="Cambiar Estado de Orden"
                  >
                    <el-option
                      v-for="item in OrderBuyOStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="No.">
                  <el-input
                    v-model="formAddOrderBuy.NoOrderBuy"
                    size="mini"
                    style="width: 220px"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Compra a No. proveedor">
                  <el-select
                    v-model="formAddOrderBuy.BuyFromVendor"
                    filterable
                    placeholder="Select"
                    @change="handleChangeProvider"
                    size="mini"
                  >
                    <el-option
                      v-for="item in optionSelectProvider"
                      :key="item.ProviderCode"
                      :label="item.PSearchN"
                      :value="item.ProviderCode"
                    >
                    </el-option>
                  </el-select>
                  <!---
                  <el-button size="mini">+</el-button>
                  -->
                </el-form-item>
                <el-form-item label="Compra a No. Contacto">
                  <el-select
                    v-model="formAddOrderBuy.BuyFromContactNo"
                    filterable
                    placeholder="Select"
                    size="mini"
                  >
                    <el-option
                      v-for="item in optionSelectContact"
                      :key="item.RegistrationNo"
                      :label="item.Name"
                      :value="item.RegistrationNo"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Compra a Nombre">
                  <el-input
                    v-model="formAddOrderBuy.ProviderName"
                    size="mini"
                    style="width: 220px"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Compra a Direccion">
                  <el-input
                    v-model="formAddOrderBuy.PBuyDirection"
                    size="mini"
                    style="width: 220px"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Compra a Colonia">
                  <el-input
                    v-model="formAddOrderBuy.PBuyDirection2"
                    size="mini"
                    style="width: 220px"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Compra a Municipio/Ciudad">
                  <el-select
                    v-model="formAddOrderBuy.PCity"
                    filterable
                    placeholder="Select"
                    size="mini"
                    :disabled="true"
                  >
                    <el-option
                      v-for="item in optionSelectCity"
                      :key="item.Code"
                      :label="item.City"
                      :value="item.City"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Compra a Estado / C.P.">
                  <el-input
                    v-model="formAddOrderBuy.PCounty"
                    size="mini"
                    style="width: 220px"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Compra a C.P">
                  <el-select
                    v-model="formAddOrderBuy.PPostCode"
                    filterable
                    placeholder="Select"
                    size="mini"
                    :disabled="true"
                  >
                    <el-option
                      v-for="item in optionSelectCity"
                      :key="item.Code"
                      :label="item.Code"
                      :value="item.Code"
                    >
                      <span style="float: left">{{ item.City }}</span>
                      <span
                        style="float: right; color: #8492a6; font-size: 13px"
                        >{{ item.Code }}</span
                      >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Tipo de NFC">
                  <el-input
                    size="mini"
                    style="width: 220px"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item label="No. Serie Comp. Fiscal">
                  <el-input
                    size="mini"
                    style="width: 220px"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item label="RNC/Cedula">
                  <el-input
                    v-model="formAddOrderBuy.PRnc"
                    size="mini"
                    style="width: 220px"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Cod. Act. Economica">
                  <el-select size="mini" :disabled="true"></el-select>
                </el-form-item>
                <el-form-item label="Texto de registro">
                  <el-input
                    v-model="formAddOrderBuy.PostingDescription"
                    size="mini"
                    style="width: 220px"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="11">
                <el-form-item label="Fecha Registro">
                  <el-date-picker
                    v-model="formAddOrderBuy.PRegistrationDate"
                    type="date"
                    placeholder="Pick a day"
                    size="mini"
                    :disabled="true"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="Fecha Pedido">
                  <el-date-picker
                    v-model="formAddOrderBuy.POrderDate"
                    type="date"
                    placeholder="Pick a day"
                    size="mini"
                    :disabled="true"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="Fecha Compromiso">
                  <el-date-picker
                    v-model="formAddOrderBuy.PCommitmentdate"
                    type="date"
                    placeholder="Pick a day"
                    size="mini"
                    :disabled="true"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="Fecha Emision Doc">
                  <el-date-picker
                    v-model="formAddOrderBuy.PIssueDate"
                    type="date"
                    placeholder="Pick a day"
                    size="mini"
                    :disabled="true"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="Estado">
                  <el-select
                    v-model="formAddOrderBuy.PStatus"
                    clearable
                    placeholder="Select"
                    size="mini"
                    :disabled="true"
                  >
                    <el-option
                      v-for="item in optionSelectStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-collapse-item>
            <el-collapse-item title="Facturacion">
              <el-col span="12">
                <el-form-item label="Pago a No. Proveedor">
                  <el-select
                    v-model="formAddOrderBuy.PaytoVendorNo"
                    filterable
                    placeholder="Select"
                    size="mini"
                    :disabled="true"
                  >
                    <el-option
                      v-for="item in optionSelectProviderFacturacion"
                      :key="item.ProviderCode"
                      :label="item.ProviderCode"
                      :value="item.ProviderCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Pago a No. Contacto">
                  <el-select
                    v-model="formAddOrderBuy.PaytoContactNo"
                    filterable
                    placeholder="Select"
                    size="mini"
                    :disabled="true"
                  >
                    <el-option
                      v-for="item in optionSelectContact"
                      :key="item.RegistrationNo"
                      :label="item.RegistrationNo"
                      :value="item.RegistrationNo"
                    >
                      <span style="float: left">{{ item.RegistrationNo }}</span>
                      <span
                        style="
                          float: right;
                          color: #8492a6;
                          font-size: 13px;
                          padding-left: 5px;
                        "
                        >{{ item.Name }}</span
                      >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Pago a Nombre">
                  <el-input
                    v-model="formAddOrderBuy.PaytoName"
                    size="mini"
                    style="width: 220px"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Direccion Pago">
                  <el-input
                    v-model="formAddOrderBuy.PaytoAddress"
                    size="mini"
                    style="width: 220px"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </div>
      <!-- <el-container>
        <el-main>
          <el-row>
            <el-col>
              <el-select
                v-model="value"
                filterable
                placeholder="Select"
                @change="handleChangeProvider"
              >
                <el-option
                  v-for="item in optionSelectProvider"
                  :key="item.ProviderCode"
                  :label="item.PSearchN"
                  :value="item.ProviderCode"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-main>
      </el-container> -->
      <div class="demo-drawer__footer" type="flex" justify="end">
        <el-button type="primary" @click="AddNewBuyOrder(formName)"
          >Agregar</el-button
        >
        <el-button @click="CancelNewBuyOrde(formName)">Cancelar</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
// import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
// import OrderBuyPro from "./OrderBuyProStatusO";
// import statusOrderbuy from "./statusOrderbuy.vue";
import {
  ColumnsOrderBuyTable,
  columnsLinesOrderBuy
} from "./ColumnsOrdersBuy/columns";
import editOrderBuy from "@/views/modules/projects/components/editOrderBuy.vue";

export default {
  name: "OrderBuy",
  components: {
    editOrderBuy
  },
  data() {
    return {
      CompanyCode: this.$store.state.user.user.CompanySelected,
      loading: false,
      items: [],
      PendingBalance: 0.0,
      sumaInvoiceCostUSD: 0.0,
      sumaInvoiceCost: 0.0,
      datosFormateados: [],
      dataDetails: [],
      drawerLine: false,
      drawerAddOrder: false,
      ListOrderNo: [],
      optionSelectProvider: [],
      optionSelectProviderFacturacion: [],
      optionSelectCity: [],
      optionSelectContact: [],
      dataProviderSelect: [],
      value: "",
      isEditOrderLine: false,
      editOrderVisible: false,
      orderData: {},
      ColumnsOrderBuyTable,
      columnsLinesOrderBuy,
      formAddOrderBuy: {
        //CAMPOS COLLAPSE GENERALES
        OrderStatus: 0,
        NoOrderBuy: "",
        BuyFromVendor: "",
        BuyFromContactNo: "",
        ProviderName: "",
        PBuyDirection: "",
        PBuyDirection2: "",
        PCity: "",
        PCounty: "",
        PPostCode: "",
        BuyFromContact: "",
        TypeNFC: "",
        GenerateNFC: 0,
        NoSerieCompFiscal: "",
        PRnc: "",
        EconomicActivityCode: "",
        PostingDescription: "",
        PRegistrationDate: "",
        POrderDate: "",
        PCommitmentdate: "",
        CustomsProcessDays: 0,
        PIssueDate: "",
        approvalDate: "",
        QuoteNo: "",
        VendorOrderNo: "",
        VendorShipmentNo: "",
        VendorInvoiceNo: "",
        OrderAddressCode: "",
        PurchaserCode: "",
        ResponsibilityCenter: "",
        AssignedUserID: "",
        JobQueueStatus: 0,
        PStatus: 0,
        OStatus: 0,
        NoImportacion: "",

        //CAMPOS COLLAPSE FACTURACION
        PaytoVendorNo: "",
        PaytoContactNo: "",
        PaytoName: "",
        PaytoAddress: ""
      },
      actions: [
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit-order-buy"
        },
        {
          icon: "el-icon-search",
          label: "Ver Lineas",
          command: "details-order-buy"
        }
      ],
      OrderLinesActions: [
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit-order-line"
        }
      ],
      optionSelectStatus: [
        {
          value: 0,
          label: "Abierto"
        },
        {
          value: 1,
          label: "Lanzado"
        },
        {
          value: 2,
          label: "Aprobacion Pendiente"
        },
        {
          value: 3,
          label: "Anticipo Pendiente"
        }
      ],
      OrderBuyOStatus: [
        {
          value: 0,
          label: " "
        },
        {
          value: 1,
          label: "En Fabrica"
        },
        {
          value: 2,
          label: "En Tránsito"
        },
        {
          value: 3,
          label: "En Aduana"
        },
        {
          value: 4,
          label: "Magycorp"
        },
        {
          value: 5,
          label: "Despachado Cliente"
        },
        {
          value: 6,
          label: "Entregado"
        },
        {
          value: 7,
          label: "Pendiente de Pago"
        }
      ]
    };
  },
  created() {
    this.getItems();
    //this.formAddOrderBuy.PRegistrationDate = new Date();
    this.FormatDate((this.formAddOrderBuy.PRegistrationDate = new Date()));
    this.FormatDate((this.formAddOrderBuy.POrderDate = new Date()));
    this.FormatDate((this.formAddOrderBuy.PCommitmentdate = new Date()));
    this.FormatDate((this.formAddOrderBuy.PIssueDate = new Date()));
  },
  computed: {
    formName() {
      return "AddBuyOrderForm";
    }
  },
  methods: {
    FormatDate(date) {
      const Originaldate = date;
      const year = Originaldate.getFullYear();
      const month = String(Originaldate.getMonth() + 1).padStart(2, "0");
      const day = String(Originaldate.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;
      //console.log("Fecha Formateada", formattedDate);
      return formattedDate;
    },

    GenerateCodeOrderBuy(LastCode) {
      // Extraer el número actual del código
      const CurrentCodeNumber = parseInt(LastCode.split("-")[1], 10);
      // Incrementar el número en 1
      const NextNumber = CurrentCodeNumber + 1;
      // Formatear el número para tener 6 dígitos con ceros a la izquierda
      const FormatNumber = String(NextNumber).padStart(6, "0");
      // Crear el nuevo código
      const newCode = `PC-${FormatNumber}-TB`;
      return newCode;
    },

    getItems() {
      this.loading = true;

      const params = {
        CompanyCode: this.CompanyCode
      };
      this.$http
        .get("/api/invoices/OrderBuy", {
          params
        })
        .then(({ data }) => {
          //console.log("buyData: ",data);
          this.items = data;
          this.sumaInvoiceCostUSD = this.items
            .filter((item) => item.CCode === "USD")
            .reduce((total, item) => total + item.InvoiceCost, 0);
          this.sumaInvoiceCost = this.items
            .filter((item) => item.CCode != "USD")
            .reduce((total, item) => total + item.InvoiceCost, 0);

          const formatoMonedaDominicana = new Intl.NumberFormat("es-DO", {
            style: "currency",
            currency: "DOP"
          });

          this.sumaInvoiceCost = formatoMonedaDominicana.format(
            this.sumaInvoiceCost
          );
          const formatoMonedaDolares = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD"
          });

          this.sumaInvoiceCostUSD = formatoMonedaDolares.format(
            this.sumaInvoiceCostUSD
          );

          this.datosFormateados = data.map((item) => {
            if (item.CCode === "USD") {
              return {
                ...item,
                InvoiceCost: item.InvoiceCost.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD"
                })
              };
            } else {
              return {
                ...item,
                InvoiceCost: item.InvoiceCost.toLocaleString("en-DO", {
                  style: "currency",
                  currency: "DOP"
                })
              };
            }
          });

          // console.log("items dejense ver:", this.items);
        })
        .catch((error) => {
          this.$message.error("Error al consultar el estado de cuenta");
          console.error(error);
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleChangeProvider(val) {
      //console.log("val", val);
      this.dataProviderSelect = [...this.optionSelectProvider];
      this.GetProvidersCollapseFacturacion();
      const dataFilterProvider = this.dataProviderSelect.filter(
        (data) => data.ProviderCode == val
      );
      //console.log("despues de filtrar", dataFilterProvider);
      this.formAddOrderBuy.ProviderName = dataFilterProvider[0].ProviderName;
      this.formAddOrderBuy.PCity = dataFilterProvider[0].PCity;
      this.GetListContactByProvider(dataFilterProvider[0].PRnc);
      this.formAddOrderBuy.BuyFromContactNo =
        dataFilterProvider[0].BuyFromContact;
      this.formAddOrderBuy.PBuyDirection = dataFilterProvider[0].PAdress;
      this.formAddOrderBuy.PCounty = dataFilterProvider[0].PCounty;
      this.formAddOrderBuy.PBuyDirection2 = dataFilterProvider[0].PAdress2;
      this.formAddOrderBuy.PRnc = dataFilterProvider[0].PRnc;
      //this.formAddOrderBuy.PBuyDirection2 = dataFilterProvider[0].PAdress2;
      this.formAddOrderBuy.PPostCode = dataFilterProvider[0].PPostCode;
      this.formAddOrderBuy.PaytoVendorNo = dataFilterProvider[0].PPaytoVendorNo;
      //this.formAddOrderBuy.PaytoContactNo = dataFilterProvider[0].PPaytoVendorNo;
      this.formAddOrderBuy.PaytoName = dataFilterProvider[0].ProviderName;
      this.formAddOrderBuy.PaytoAddress = dataFilterProvider[0].PAdress;
    },

    GetListContactByProvider(RegistrationNo) {
      this.loading = true;
      this.$http
        .get(
          `/api/invoices/ListContactByProvider?RegistrationNo=${RegistrationNo}`
        )
        .then((resp) => {
          this.optionSelectContact = resp.data;
          //console.log("Resp op", this.optionSelectContact);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    GetProvidersCollapseGeneral() {
      this.loading = true;
      this.$http
        .get(`/api/Proyects/GetProviders?companyCode=${this.currentCompany}`)
        .then((resp) => {
          this.optionSelectProvider = resp.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    GetProvidersCollapseFacturacion() {
      this.loading = true;
      this.$http
        .get(`/api/Proyects/GetProviders?companyCode=${this.currentCompany}`)
        .then((resp) => {
          this.optionSelectProviderFacturacion = resp.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    GetListCity() {
      this.loading = true;
      this.$http
        .get("/api/invoices/ListCityNavision")
        .then((resp) => {
          this.optionSelectCity = resp.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    GetListNoOrderBuy() {
      this.loading = true;
      this.$http
        .get("/api/invoices/ListNoOrderBuy")
        .then((resp) => {
          this.ListOrderNo = resp.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;

          if (this.ListOrderNo.length == 0) {
            const InitialCode = "TB-000000";
            let newCode = this.GenerateCodeOrderBuy(InitialCode);
            this.formAddOrderBuy.NoOrderBuy = newCode;
            this.formAddOrderBuy.PostingDescription = `Pedido ${newCode}`;
          } else {
            const ultimoElemento =
              this.ListOrderNo[this.ListOrderNo.length - 1];
            const test = JSON.stringify(ultimoElemento);
            let siguienteCodigo = "";
            siguienteCodigo = this.GenerateCodeOrderBuy(test);
            //console.log("nuevo codigo", siguienteCodigo);
            this.formAddOrderBuy.NoOrderBuy = siguienteCodigo;
          }
        });
    },

    openDrawerAdd() {
      this.drawerAddOrder = true;
      this.GetProvidersCollapseGeneral();
      this.GetListCity();
      this.GetListNoOrderBuy();
    },

    handlerAction(action) {
      const { command } = action;

      switch (command) {
        case "edit-order-line":
          //console.log("action in lines: ", action);
          this.orderData = action.row;
          this.isEditOrderLine = true;
          this.editOrderVisible = true;

          break;

        case "edit-order-buy":
          //console.log("action", action);
          this.orderData = action.row;
          this.isEditOrderLine = false;
          this.editOrderVisible = true;

          break;
        case "details-order-buy":
          //console.log("action", action);
          this.getDetailData(action.row.No);
          break;
      }
    },
    getDetailData: function (OrderNo) {
      this.$http
        .get("/api/invoices/OrderBuyDetails", {
          params: {
            DocumentNo: OrderNo,
            CompanyCode: this.CompanyCode
          }
        })
        .then(({ data }) => {
          this.dataDetails = data;
          //console.log("Data Details", data);
          this.drawerLine = true;
          //Abdiel estuvo aqui
        });
    },
    onOrderEdited: function (isEditOrderLine, OrderNo) {
      if (isEditOrderLine) {
        this.getDetailData(OrderNo);
      }
      this.getItems();
      this.editOrderVisible = false;
    },
    onCloseOrderEdit: function (val) {
      this.editOrderVisible = val;
    },
    AddNewBuyOrder: function (formName) {
      const params = {
        No_: this.formAddOrderBuy.NoOrderBuy,
        Buy_from_Vendor_No_: this.formAddOrderBuy.BuyFromVendor,
        Order_Status: this.formAddOrderBuy.OStatus
      };
      this.$http
        .post("/api/invoices/AddNewOrderBuy", params)
        .then((resp) => {
          //console.log("se agrego la orden: ", resp);
          resp;
          this.getItems();
          this.$refs[formName].resetFields();
          this.drawerAddOrder = false;
        })
        .catch((err) => {
          console.error("Error al agregar nueva orden: ", err);
        });
    },
    CancelNewBuyOrde: function (formName) {
      this.$refs[formName].resetFields();
      this.drawerAddOrder = false;
    }
  }
};
</script>
<style></style>
